export default {
  partOfTeam: {
    title: '¡Ven a formar parte del #timeSIS!',
    description:
      'Tenemos la vacante ideal para ti. Ven a formar parte de una empresa que acoge al colaborador, le ofrece diversos beneficios y lo apoya en su desarrollo.',
    buttonText: 'Ven a ser SIS',
  },
}
